import styled from 'styled-components';

import { bodySemibold } from 'styles/mixins/fonts';

export const Label = styled.p`
  ${bodySemibold};
  margin-bottom: 30px;
  color: ${({ theme }) => theme.config.input.label.default};
`;
